var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app", attrs: { id: "app" } },
    [
      _c("app-refresh"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("app-toaster"),
      _vm._v(" "),
      _vm.$featureFlag("enableCookieConsent") ? _c("app-cookie") : _vm._e(),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "app-modal" } }),
      _vm._v(" "),
      _c("vue-up")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }